// «Добавить в тур»: позиция раздела «Места» уходит в «Мой тур» событием trip:add
// (контракт — TripItem в shared/lib/types; собирает тур features/planner, здесь — только отправка).
import { bus } from '../../shared/lib/bus';
import type { TripItem } from '../../shared/lib/types';
import type { ExploreTripItem } from './model';

/** Пустые поля не отправляем: в туре хранится только известное */
export function cleanTrip(item: ExploreTripItem): TripItem {
  const out: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(item)) {
    if (v === undefined || v === '' || (typeof v === 'number' && !Number.isFinite(v))) continue;
    out[k] = v;
  }
  return out as unknown as TripItem;
}

export function addPoiToTrip(item: ExploreTripItem): void {
  bus.emit('trip:add', cleanTrip(item));
}

// Позиция раздела «Места» совместима с контрактом шины (проверка при сборке)
export const tripCompatible = (x: ExploreTripItem): TripItem => x;
